import { ComponentType } from '../table_component'
import { SchemaColumn } from '../types'

export interface CommonData {
  name: string
  mean: string
  std: string
  location: string
}

export const commonColumns: SchemaColumn[] = [
  {
    id: 'no',
    name: 'No.',
    component: ComponentType.NO
  },
  {
    id: 'name',
    name: 'Statistic Name',
    component: ComponentType.Text
  },
  {
    id: 'mean',
    name: 'Mean',
    component: ComponentType.MetricStats
  },
  {
    id: 'std',
    name: 'Std',
    component: ComponentType.MetricStats
  },
  {
    id: 'location',
    name: 'Metric Location',
    component: ComponentType.Text
  }
]
